import { render, staticRenderFns } from "./contractRemind.vue?vue&type=template&id=1fcbc7ba&scoped=true"
import script from "./contractRemind.vue?vue&type=script&lang=js"
export * from "./contractRemind.vue?vue&type=script&lang=js"
import style0 from "./contractRemind.vue?vue&type=style&index=0&id=1fcbc7ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbc7ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fcbc7ba')) {
      api.createRecord('1fcbc7ba', component.options)
    } else {
      api.reload('1fcbc7ba', component.options)
    }
    module.hot.accept("./contractRemind.vue?vue&type=template&id=1fcbc7ba&scoped=true", function () {
      api.rerender('1fcbc7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/contractRemind.vue"
export default component.exports